import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/* -------------------------------------------------------
   CONFIG — ปรับได้ตามแบรนด์
------------------------------------------------------- */
const THEME = {
  fontFamily: "'Prompt', system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial, 'Noto Sans Thai', sans-serif",
  primary: "#0ea5e9", // ฟ้าอ่อนหรูๆ
  textOnDark: "rgba(255,255,255,.92)",
  glass: "rgba(255,255,255,.08)",
  glassStroke: "rgba(255,255,255,.18)",
  pageBg: "#0b1220", // น้ำเงินเข้มแบบหรู
};

// วิดีโอ/ภาพ hero — หากไม่มีวิดีโอจะใช้ภาพแทน
const HERO_MEDIA = {
  video:
    "https://cdn.coverr.co/videos/coverr-reading-a-book-1261/1080p.mp4", // เปลี่ยนเป็นไฟล์ของคุณได้
  image:
    "https://images.unsplash.com/photo-1534131707746-25d604851a1f?q=80&w=2000&auto=format&fit=crop",
};

/* -------------------------------------------------------
   MOCK DATA — เปลี่ยนเป็นข้อมูลจริงได้ทันที
------------------------------------------------------- */
const ARTICLES = [
  {
    id: "a1",
    title: "คู่มือการติดตามทวงหนี้อย่างถูกกฎหมาย (อัปเดต 2025)",
    category: "ทวงหนี้",
    date: "2025-08-22",
    readMins: 8,
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "ขั้นตอน สิทธิ และข้อห้ามที่ลูกหนี้–เจ้าหนี้ต้องรู้ พร้อมเช็กลิสต์เอกสารก่อนเริ่มดำเนินการ",
    featured: true,
  },
  {
    id: "a2",
    title: "วางแผนทรัพย์สินก่อนการหย่า: ปกป้องสิทธิอย่างมืออาชีพ",
    category: "ครอบครัว",
    date: "2025-07-12",
    readMins: 6,
    image:
      "https://www.lawdepot.com/images/lawLibrary/Articles/are-divorce-records-public.jpg",
    excerpt:
      "ทำความเข้าใจสินสมรส สินส่วนตัว และแนวทางไกล่เกลี่ยเพื่อลดความขัดแย้ง",
    featured: true,
  },
  {
    id: "a3",
    title: "บริษัทติดหนี้เสีย คุยอย่างไรให้แบงก์ยอมโครงสร้างหนี้",
    category: "ธุรกิจ",
    date: "2025-06-30",
    readMins: 7,
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "เทคนิค restructuring สำหรับ SME: cashflow, หลักประกัน และ term ที่ควรเจรจา",
  },
  {
    id: "a4",
    title: "ภาษีหนี้สูญ: ตัดหนี้ลูกหนี้เบี้ยวให้ถูกต้อง",
    category: "ภาษี",
    date: "2025-05-14",
    readMins: 5,
    image:
      "https://images.unsplash.com/photo-1542621334-a254cf47733d?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "เงื่อนไขเอกสารและระยะเวลาที่สรรพากรยอมรับ พร้อมตัวอย่างเอกสารประกอบ",
  },
  {
    id: "a5",
    title: "Checklist ทวงหนี้สำหรับธุรกิจบริการรายเดือน",
    category: "ทวงหนี้",
    date: "2025-04-25",
    readMins: 4,
    image:
      "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "จากออกบิล → แจ้งเตือน → หนังสือทวงถาม → ส่งทนายความ: ทำทีละขั้น ปิดหนี้เร็วขึ้น",
  },
  {
    id: "a6",
    title: "ข้อตกลงก่อนสมรส (Prenup) จำเป็นเมื่อไร?",
    category: "ครอบครัว",
    date: "2025-03-19",
    readMins: 5,
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "กรอบกฎหมายไทย ข้อควรระวัง และตัวอย่างเงื่อนไขยอดนิยมที่คนส่วนใหญ่มองข้าม",
  },
  {
    id: "a7",
    title: "สัญญาให้กู้ยืม: เขียนยังไงให้ฟ้องได้จริง",
    category: "กฎหมายบริษัท",
    date: "2025-02-03",
    readMins: 9,
    image:
      "https://images.unsplash.com/photo-1473181488821-2d23949a045a?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "หัวใจอยู่ที่พยานหลักฐานและดอกเบี้ยตามกฎหมาย—ตัวอย่างถ้อยคำที่ใช้ได้ผล",
  },
  {
    id: "a8",
    title: "กฎหมายโทรทวงหนี้: เส้นบาง ๆ ระหว่าง ‘ติดตามสิทธิ’ กับ ‘คุกคาม’",
    category: "ทวงหนี้",
    date: "2025-01-11",
    readMins: 6,
    image:
      "https://images.unsplash.com/photo-1510070009289-b5bc34383727?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "เวลาที่โทรได้–ไม่ได้, สถานที่ต้องห้าม, และหลักฐานที่ควรเก็บทุกครั้ง",
  },
  {
    id: "a9",
    title: "โครงสร้างผู้ถือหุ้นเพื่อการบริหารความเสี่ยง",
    category: "กฎหมายบริษัท",
    date: "2024-12-20",
    readMins: 7,
    image:
      "https://images.unsplash.com/photo-1523958203904-cdcb402031fd?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "ชั้นบริษัท โฮลดิ้ง และ shareholder agreement: เลือกให้เหมาะธุรกิจคุณ",
  },
  {
    id: "a10",
    title: "สรุปคดีจริง: ทนายความฟ้องทวงหนี้สำเร็จได้อย่างไร",
    category: "ทวงหนี้",
    date: "2024-11-08",
    readMins: 10,
    image:
      "https://images.unsplash.com/photo-1519642918688-7e43b19245d8?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "จากหลักฐานชำระเงินถึงคำพิพากษา—บทเรียนที่องค์กรควรนำไปใช้",
  },
  {
    id: "a11",
    title: "การหย่าด้วยความเข้าใจ: ขั้นตอนและเวลาโดยประมาณ",
    category: "ครอบครัว",
    date: "2024-10-02",
    readMins: 4,
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "ทางเลือกระหว่างจดการหย่าที่อำเภอกับฟ้องศาล พร้อมไทม์ไลน์คร่าว ๆ",
  },
  {
    id: "a12",
    title: "ภาษีธุรกรรมเมื่อโอนหุ้นภายในกลุ่ม",
    category: "ภาษี",
    date: "2024-09-17",
    readMins: 6,
    image:
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=1600&auto=format&fit=crop",
    excerpt:
      "อากรแสตมป์ ภาษีเงินได้ และเอกสารที่กรมสรรพากรตรวจบ่อย",
  },
];

// Tags are now dynamic from translations in the component body

/* -------------------------------------------------------
   UTILITIES
------------------------------------------------------- */
const fmtDate = (iso, lang) =>
  new Date(iso).toLocaleDateString(lang === "th" ? "th-TH" : "en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

/* -------------------------------------------------------
   PAGE
------------------------------------------------------- */
export default function ArticlesPage() {
  const { t, i18n } = useTranslation();
  
  const ARTICLES_DATA = useMemo(() => {
    const raw = [
      { id: "a1", date: "2025-08-22", readMins: 8, image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1600&auto=format&fit=crop", featured: true },
      { id: "a2", date: "2025-07-12", readMins: 6, image: "https://www.lawdepot.com/images/lawLibrary/Articles/are-divorce-records-public.jpg", featured: true },
      { id: "a3", date: "2025-06-30", readMins: 7, image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop" },
      { id: "a4", date: "2025-05-14", readMins: 5, image: "https://images.unsplash.com/photo-1542621334-a254cf47733d?q=80&w=1600&auto=format&fit=crop" },
      { id: "a5", date: "2025-04-25", readMins: 4, image: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1600&auto=format&fit=crop" },
      { id: "a6", date: "2025-03-19", readMins: 5, image: "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1600&auto=format&fit=crop" },
      { id: "a7", date: "2025-02-03", readMins: 9, image: "https://images.unsplash.com/photo-1473181488821-2d23949a045a?q=80&w=1600&auto=format&fit=crop" },
      { id: "a8", date: "2025-01-11", readMins: 6, image: "https://images.unsplash.com/photo-1510070009289-b5bc34383727?q=80&w=1600&auto=format&fit=crop" },
      { id: "a9", date: "2024-12-20", readMins: 7, image: "https://images.unsplash.com/photo-1523958203904-cdcb402031fd?q=80&w=1600&auto=format&fit=crop" },
      { id: "a10", date: "2024-11-08", readMins: 10, image: "https://images.unsplash.com/photo-1519642918688-7e43b19245d8?q=80&w=1600&auto=format&fit=crop" },
      { id: "a11", date: "2024-10-02", readMins: 4, image: "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1600&auto=format&fit=crop" },
      { id: "a12", date: "2024-09-17", readMins: 6, image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=1600&auto=format&fit=crop" },
    ];
    return raw.map(item => ({
      ...item,
      ...t(`articles.data.${item.id}`, { returnObjects: true })
    }));
  }, [t]);

  const TAGS_MAP = t("articles.tags", { returnObjects: true });
  const TAGS_LIST = Object.values(TAGS_MAP);

  const [q, setQ] = useState("");
  const [tag, setTag] = useState(TAGS_MAP.all);
  const [sort, setSort] = useState("new"); // new | popular | read
  const [limit, setLimit] = useState(9);
  const [loading, setLoading] = useState(true);
  const heroRef = useRef(null);

  // simulate loading
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 700);
    return () => clearTimeout(t);
  }, []);

  // Parallax hero
  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const onScroll = () => {
      const y = window.scrollY;
      el.style.setProperty("--parallax", Math.min(y * 0.22, 120) + "px");
      el.style.setProperty("--blur", Math.min(y / 70, 8) + "px");
      el.style.setProperty("--fade", Math.min(y / 420, 0.5));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Filter + sort
  const list = useMemo(() => {
    const kw = q.trim().toLowerCase();
    let rows = ARTICLES_DATA.filter((a) => {
      const matchTag = tag === TAGS_MAP.all || a.category === tag;
      const matchQ =
        !kw ||
        a.title.toLowerCase().includes(kw) ||
        a.excerpt.toLowerCase().includes(kw) ||
        a.category.toLowerCase().includes(kw);
      return matchTag && matchQ;
    });

    if (sort === "new") {
      rows = rows.sort((a, b) => new Date(b.date) - new Date(a.date));
    } else if (sort === "read") {
      rows = rows.sort((a, b) => a.readMins - b.readMins);
    } else if (sort === "popular") {
      rows = rows.sort((a, b) => Number(b.featured) - Number(a.featured));
    }
    return rows;
  }, [q, tag, sort, ARTICLES_DATA, TAGS_MAP.all]);

  const visible = list.slice(0, limit);

  // Scroll reveal
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("reveal-in");
        }),
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [loading, limit, tag, q, sort]);

  return (
    <div className="articles-page" style={{ fontFamily: THEME.fontFamily, marginBottom: "-30px" }}>
      <Style />

      {/* ===== HERO ===== */}
      <section className="hero" ref={heroRef}>
        {HERO_MEDIA.video ? (
          <video
            className="hero-media"
            autoPlay
            loop
            muted
            playsInline
            poster={HERO_MEDIA.image}
          >
            <source src={HERO_MEDIA.video} type="video/mp4" />
          </video>
        ) : (
          <img className="hero-media" src={HERO_MEDIA.image} alt="" />
        )}

        <div className="hero-overlay" />

        <div className="hero-content">
          <div className="hero-badge reveal">{t("articles.hero_badge")}</div>
          <h1 className="hero-title reveal">
            {t("articles.hero_title")}
            <span className="grad">{t("articles.hero_title_accent")}</span>
          </h1>
          <p className="hero-sub reveal">
            {t("articles.hero_sub").split("**").map((part, i) => i % 2 === 1 ? <b key={i}>{part}</b> : part)}
          </p>

          <div className="hero-cta reveal">
            <a className="btn-cta" href="/contact">
              {t("articles.consult_btn")}
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path
                  d="M5 12h12M13 5l7 7-7 7"
                  stroke="currentColor"
                  fill="none"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>

        <div className="hero-bottom-fade" />
      </section>

      {/* ===== TOOLBAR ===== */}
      <section className="toolbar reveal" > 
        <div className="toolbar-inner">
          <div className="search">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <circle cx="11" cy="11" r="7" stroke="currentColor" fill="none" />
              <path d="M20 20l-3.5-3.5" stroke="currentColor" />
            </svg>
            <input
              placeholder={t("articles.search_placeholder")}
              value={q}
              onChange={(e) => {
                setQ(e.target.value);
                setLimit(9);
              }}
            />
          </div>

          <div className="tags">
            {TAGS_LIST.map((t) => (
              <button
                key={t}
                className={`chip ${tag === t ? "active" : ""}`}
                onClick={() => {
                  setTag(t);
                  setLimit(9);
                }}
              >
                {t}
              </button>
            ))}
          </div>

          <div className="sort">
            <label>{t("articles.sort_label")}</label>
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="new">{t("articles.sort_new")}</option>
              <option value="popular">{t("articles.sort_popular")}</option>
              <option value="read">{t("articles.sort_read")}</option>
            </select>
          </div>
        </div>
      </section>

      {/* ===== FEATURED ===== */}
      <section className="featured" >
        {loading ? (
          <div className="skeleton featured-skeleton" />
        ) : (
          ARTICLES_DATA.filter((a) => a.featured)
            .slice(0, 2)
            .map((a) => (
              <a key={a.id} href={`/articles/${a.id}`} className="feature-card reveal">
                <img src={a.image} alt="" loading="lazy" />
                <div className="fgrad" />
                <div className="fmeta">
                  <span className="fcat">{a.category}</span>
                  <h3 className="ftitle">{a.title}</h3>
                  <p className="fdesc">{a.excerpt}</p>
                  <div className="fmore">
                    {t("articles.read_more")} • {fmtDate(a.date, i18n.language)} • {a.readMins} {t("articles.read_mins")}
                  </div>
                </div>
              </a>
            ))
        )}
      </section>

      {/* ===== GRID ===== */}
      <section className="grid">
        {loading
          ? Array.from({ length: 9 }).map((_, i) => (
              <div className="skeleton card-skeleton" key={i} />
            ))
          : visible.map((a) => <ArticleCard key={a.id} {...a} />)}
      </section>

      {/* ===== LOAD MORE ===== */}
      {!loading && visible.length < list.length && (
        <div className="loadmore">
          <button
            className="btn-load reveal"
            onClick={() => setLimit((n) => n + 6)}
          >
            {t("articles.load_more", { count: Math.min(6, list.length - visible.length) })}
          </button>
          <div className="count">
            {t("articles.show_count", { visible: visible.length, total: list.length })}
          </div>
        </div>
      )}

      {/* ===== FLOATING CTA ===== */}
      <a className="floating-cta" href="/contact" aria-label={t("articles.floating_cta")} >
        {t("articles.floating_cta")}
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path
            d="M5 12h12M13 5l7 7-7 7"
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </div>
  );
}

/* -------------------------------------------------------
   CARD
------------------------------------------------------- */
function ArticleCard({ id, title, category, date, readMins, image, excerpt }) {
  const { t, i18n } = useTranslation();
  return (
    <a href={`/articles/${id}`} className="card reveal"  >
      <div className="cover">
        <img src={image} alt="" loading="lazy" />
        <div className="overlay" />
        <span className="badge">{category}</span>
      </div>
      <div className="body">
        <h3 className="title">{title}</h3>
        <p className="excerpt">{excerpt}</p>
        <div className="meta">
          <span>{fmtDate(date, i18n.language)}</span>
          <span>•</span>
          <span>{readMins} {t("articles.read_mins")}</span>
        </div>
      </div>
      <div className="arrow">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path
            d="M5 12h12M13 5l7 7-7 7"
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </a>
  );
}

/* -------------------------------------------------------
   STYLES (scoped)
------------------------------------------------------- */
function Style() {
  return (
    <style>{`
:root {
  --page-bg: ${THEME.pageBg};
  --text-on-dark: ${THEME.textOnDark};
  --glass: ${THEME.glass};
  --glass-stroke: ${THEME.glassStroke};
  --primary: ${THEME.primary};
}

* { box-sizing: border-box; }
.articles-page {
  color: var(--text-on-dark);
  background: radial-gradient(1200px 600px at 10% -10%, rgba(14,165,233,.12), transparent 60%),
              radial-gradient(1200px 600px at 90% 10%, rgba(99,102,241,.12), transparent 60%),
              var(--page-bg);
  min-height: 100vh;
}

/* ===== HERO ===== */
.hero {
  position: relative;
  height: clamp(60vh, 72vh, 78vh);
  overflow: hidden;
  isolation: isolate;
  --parallax: 0px;
  --blur: 0px;
  --fade: 0;
}
.hero-media {
  position: absolute; inset: -10% -10% -10% -10%;
  width: 120%; height: 120%;
  object-fit: cover;
  transform: translateY(var(--parallax));
  filter: blur(var(--blur)) brightness(0.8) saturate(0.9);
  will-change: transform, filter;
}
.hero-overlay {
  position: absolute; inset: 0;
  background: radial-gradient(1000px 600px at 15% 30%, rgba(0,0,0,.45), rgba(0,0,0,.6)),
              linear-gradient(to right, rgba(0,0,0,.55), rgba(0,0,0,.25), rgba(0,0,0,.55));
  opacity: calc(1 - var(--fade) * .35);
}
.hero-bottom-fade {
  position: absolute; left:0; right:0; bottom:-1px; height: 120px;
  background: linear-gradient(to bottom, transparent, var(--page-bg));
  z-index: 2;
}
.hero-content {
  position: relative; z-index: 3;
  height: 100%;
  display: grid;
  align-content: center;
  gap: 16px;
  padding: clamp(20px, 5vw, 64px);
  max-width: 1200px;
  margin: 0 auto;
}
.hero-badge {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 999px;
  background: var(--glass);
  backdrop-filter: blur(8px);
  border: 1px solid var(--glass-stroke);
  width: fit-content;
  font-size: .95rem;
}
.hero-title {
  font-size: clamp(2.2rem, 4.5vw, 4.2rem);
  line-height: 1.1;
  letter-spacing: .2px;
  margin: 0;
  font-weight: 800;
}
.hero-title .grad {
  display: inline-block;
  background: linear-gradient(90deg, #60a5fa, #22d3ee, #34d399);
  -webkit-background-clip: text; background-clip: text;
  color: transparent;
}
.hero-sub {
  max-width: 56ch;
  opacity: .9;
  font-size: clamp(1rem, 1.2vw, 1.1rem);
}
.btn-cta {
  display:inline-flex; align-items:center; gap:10px;
  padding: 12px 18px;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255,255,255,.18), rgba(255,255,255,.06));
  border: 1px solid var(--glass-stroke);
  backdrop-filter: blur(8px);
  color: white; text-decoration: none; font-weight: 600;
  transition: transform .2s ease, background .2s ease;
}
.btn-cta:hover { transform: translateY(-1px); background: rgba(255,255,255,.22); }

/* ===== TOOLBAR ===== */
.toolbar { margin-top: -36px; position: relative; z-index: 4; }
.toolbar-inner {
  max-width: 1200px; margin: 0 auto;
  display: grid; gap: 14px; padding: 0 clamp(16px, 4vw, 24px);
  grid-template-columns: 1.2fr 2fr auto;
}
.search {
  display:flex; align-items:center; gap:10px;
  background: var(--glass); border: 1px solid var(--glass-stroke);
  padding: 12px 14px; border-radius: 14px; backdrop-filter: blur(8px);
}
.search input {
  background: transparent; border: none; outline: none; color: var(--text-on-dark);
  width: 100%; font-size: 1rem;
}
.tags { display: flex; gap: 10px; flex-wrap: wrap; }
.chip {
  padding: 10px 14px; border-radius: 999px; border: 1px solid var(--glass-stroke);
  background: rgba(255,255,255,.06); color: white; cursor: pointer;
  transition: transform .15s ease, background .2s ease, border-color .2s ease;
}
.chip:hover { transform: translateY(-1px); background: rgba(255,255,255,.1); }
.chip.active { background: linear-gradient(90deg, rgba(96,165,250,.35), rgba(34,211,238,.35)); border-color: rgba(255,255,255,.25); }
.sort { display:flex; align-items:center; gap:8px; justify-self: end; }
.sort select {
  appearance: none; padding: 10px 14px; border-radius: 12px; border: 1px solid var(--glass-stroke);
  background: var(--glass); color: white; backdrop-filter: blur(8px);
}

/* ===== FEATURED ===== */
.featured {
  max-width: 1200px; margin: 18px auto 6px; padding: 0 clamp(16px,4vw,24px);
  display: grid; gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.feature-card {
  position: relative; overflow: hidden; border-radius: 20px; isolation: isolate;
  background: #111827; text-decoration: none; color: white; min-height: 260px;
  transition: transform .25s ease, box-shadow .25s ease;
  border: 1px solid rgba(255,255,255,.08);
}
.feature-card:hover { transform: translateY(-2px); box-shadow: 0 15px 40px rgba(0,0,0,.35); }
.feature-card img { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; filter:brightness(.9) saturate(.95); transform: scale(1.02); transition: transform .6s ease; }
.feature-card:hover img { transform: scale(1.06); }
.feature-card .fgrad { position:absolute; inset:0; background: linear-gradient(180deg, rgba(0,0,0,.0), rgba(0,0,0,.6) 60%, rgba(0,0,0,.85)); }
.feature-card .fmeta { position:absolute; inset:auto 16px 16px 16px; display:grid; gap:8px; }
.fcat { display:inline-block; padding:6px 10px; border-radius:999px; background: rgba(255,255,255,.12); border: 1px solid rgba(255,255,255,.2); width:fit-content; font-size:.85rem;}
.ftitle { margin:0; font-size: clamp(1.05rem, 1.8vw, 1.4rem); font-weight: 800; }
.fdesc { margin:0; opacity:.9; line-height:1.5; max-width: 60ch; }
.fmore { opacity:.8; font-size:.95rem; }

/* ===== GRID ===== */
.grid {
  max-width: 1200px; margin: 18px auto 30px; padding: 0 clamp(16px,4vw,24px);
  display: grid; gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.card {
  position: relative; overflow:hidden; border-radius: 18px; display:flex; flex-direction: column;
  text-decoration: none; color: white; background: rgba(255,255,255,.04);
  border: 1px solid rgba(255,255,255,.08); transition: transform .18s ease, box-shadow .18s ease;
}
.card:hover { transform: translateY(-3px); box-shadow: 0 10px 30px rgba(0,0,0,.35); }
.card .cover { position: relative; aspect-ratio: 16 / 9; overflow: hidden; }
.card .cover img { width:100%; height:100%; object-fit:cover; transform: scale(1.02); transition: transform .6s ease; filter: saturate(.95) brightness(.95); }
.card:hover .cover img { transform: scale(1.07); }
.card .cover .overlay { position:absolute; inset:0; background: linear-gradient(180deg, rgba(0,0,0,.0), rgba(0,0,0,.75)); opacity:.9; }
.card .badge { position:absolute; left:12px; top:12px; background: rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.28); backdrop-filter: blur(6px);
  padding:6px 10px; border-radius:999px; font-size:.85rem; }
.card .body { display:grid; gap:8px; padding: 14px 14px 16px; }
.card .title { margin:0; font-size: 1.08rem; line-height:1.35; font-weight: 800; }
.card .excerpt { margin:0; opacity:.9; font-size: .98rem; line-height:1.55; }
.card .meta { display:flex; gap:8px; align-items:center; opacity:.8; font-size:.95rem; }
.card .arrow { position:absolute; right:12px; bottom:12px; opacity:.75; transition: transform .2s ease, opacity .2s ease; }
.card:hover .arrow { transform: translateX(3px); opacity:1; }

/* ===== LOAD MORE ===== */
.loadmore { display:grid; justify-items:center; gap:10px; padding: 8px 0 60px; }
.btn-load {
  padding: 12px 20px; border-radius: 999px; border:1px solid var(--glass-stroke);
  background: var(--glass); color:white; cursor:pointer; backdrop-filter: blur(8px);
  transition: transform .15s ease, background .2s ease;
}
.btn-load:hover { transform: translateY(-1px); background: rgba(255,255,255,.12); }
.count { opacity:.8; }

/* ===== FLOATING CTA ===== */
.floating-cta {
  position: fixed; right: 18px; bottom: 18px; z-index: 50;
  display:inline-flex; align-items:center; gap:8px;
  padding: 12px 16px; border-radius: 999px; text-decoration:none; color:white;
  background: linear-gradient(180deg, rgba(255,255,255,.22), rgba(255,255,255,.08));
  border: 1px solid var(--glass-stroke); backdrop-filter: blur(10px);
  transition: transform .2s ease, background .2s ease; box-shadow: 0 8px 28px rgba(0,0,0,.28);
}
.floating-cta:hover { transform: translateY(-2px); background: rgba(255,255,255,.26); }

/* ===== REVEAL ANIMATION ===== */
.reveal { opacity: 0; transform: translateY(14px) scale(.98); }
.reveal-in { animation: rise .6s cubic-bezier(.2,.7,.2,1) forwards; }
@keyframes rise {
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* ===== SKELETON ===== */
.skeleton {
  position: relative; overflow:hidden; border-radius: 18px;
  background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.08);
}
.skeleton::after {
  content:""; position:absolute; inset:0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.12), transparent);
  transform: translateX(-100%); animation: shimmer 1.4s infinite;
}
@keyframes shimmer { to { transform: translateX(100%); } }
.featured-skeleton { min-height: 260px; }
.card-skeleton { aspect-ratio: 16/11; }

/* ===== RESPONSIVE ===== */
@media (max-width: 1024px) {
  .toolbar-inner { grid-template-columns: 1fr; }
  .featured { grid-template-columns: 1fr; }
  .grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 640px) {
  .hero { height: 64vh; }
  .grid { grid-template-columns: 1fr; }
  .hero-sub { max-width: 46ch; }
}
    `}</style>
  );
}
